/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddInspectorEvaluationCommand } from '../../models/add-inspector-evaluation-command';
import { BaseCommandResult } from '../../models/base-command-result';

export interface ApiPlanAddInspectorEvaluationPatch$Plain$Params {
  
    /**
     * Add Inspector Evaluation command
     */
    body?: AddInspectorEvaluationCommand
}

export function apiPlanAddInspectorEvaluationPatch$Plain(http: HttpClient, rootUrl: string, params?: ApiPlanAddInspectorEvaluationPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiPlanAddInspectorEvaluationPatch$Plain.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseCommandResult>;
    })
  );
}

apiPlanAddInspectorEvaluationPatch$Plain.PATH = '/api/Plan/AddInspectorEvaluation';
